import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';

import { mergeRefs } from '../../../lib/utils';
import styles from './TextArea.module.scss';
import usePresenter from './TextArea.presenter';
import { TextAreaCombinedProps } from './types';

// MANUAL OVERRIDE - converted to forwardRef Component
const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaCombinedProps>((props, ref) => {
  const {
    styleType,
    size,
    className,
    classes,
    textValue,
    textPlaceholder,
    onTextChanged,
    onClick,
    onDoubleClick,
    onFocus,
    onBlur,
    onKeyDown,
    disabled,
    tabIndex,
  } = usePresenter(props);

  const variantName = `${styleType}${size}`;
  const currentStyle = styles[`textArea${variantName}`];

  const [inputValue, setInputValue] = useState<string>('');
  const localRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (!localRef.current || !props.resizeToContent) {
      return;
    }

    // Resize on every change
    const textArea = localRef.current;
    textArea.style.height = 'auto';
    textArea.style.height = `${textArea.scrollHeight}px`;
    textArea.style.overflowY = 'hidden';
  }, [localRef.current, props.resizeToContent, inputValue]);

  useEffect(() => {
    setInputValue(textValue || '');
  }, [textValue]);

  const onInputChanged = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onTextChanged) {
      onTextChanged(localRef, event);
    }
    setInputValue(event.target.value);
  };

  let componentView;

  switch (variantName) {
    case 'DarkMedium':
    case 'DarkSmall':
    case 'DisabledSmall':
    case 'WhiteMedium': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <textarea
            className={cx(styles.textarea, classes?.textarea)}
            placeholder={textPlaceholder}
            value={inputValue}
            onChange={onInputChanged}
            onClick={onClick} // MANUAL OVERRIDE
            onDoubleClick={onDoubleClick} // MANUAL OVERRIDE
            onFocus={onFocus} // MANUAL OVERRIDE
            onBlur={onBlur} // MANUAL OVERRIDE
            onKeyDown={onKeyDown} // MANUAL OVERRIDE
            ref={mergeRefs(localRef, ref)} // MANUAL OVERRIDE
            disabled={disabled} // MANUAL OVERRIDE
            tabIndex={tabIndex} // MANUAL OVERRIDE
          />
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
}); // MANUAL OVERRIDE

export default TextArea;
